import { render, staticRenderFns } from "./ControlLiquidos.vue?vue&type=template&id=1070c53c&"
import script from "./ControlLiquidos.vue?vue&type=script&lang=js&"
export * from "./ControlLiquidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports